export default __webpack_public_path__ + "static/media/sc.02a12d66.png";